import React from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import { boughtProductMobx, decorationMobx, buyTogetherMobx } from '@mobxStore'
import { cartMobx } from 'restaurant'
import ProductItem from './ProductItem'
import './index.scss'

interface IProps {
  style: { [key: string]: any };
}

const BoughtProducts: React.FC<IProps> = ({ style }) => {
  const { boughtViewProduct } = boughtProductMobx
  const { mealDecorates } = decorationMobx
  const isBuyTogether = !!Config.buyTogetherId
  return (
    boughtViewProduct.length && mealDecorates.showBought ? (
      <div
        className='waterfall-bought-products product-item waterfall mini'
        style={style}
        id='waterfallproductbought'
      >
        <p className='bought-title'>{i18n.t('menu.bought')}</p>
        <div className='bought-list'>
          {
            boughtViewProduct.length ? (
              boughtViewProduct.map(product => {
                const count = isBuyTogether ? buyTogetherMobx.productNoToCntMapForMenu?.[product.no] || 0 : cartMobx.cartResult?.productNoToCntMap?.[product.no] || 0
                return (
                  <ProductItem
                    key={`bought-${product.no}`}
                    product={product}
                    count={count}
                    lazy={false}
                    decorate={mealDecorates}
                  />
                )
              })
            ) : null
          }
        </div>
      </div>
    ) : null
  )
}

export default observer(BoughtProducts)
